import { handleShopifyLogout } from '../../../../../utils/signInOutUp/AuthenticationHelper';
import { ApiResponse } from '@jbhi-fi/apis/src/types';
import CustomerHelper from '../../helpers/CustomerHelper';
import { serviceHelper } from '../../../../../config/service-helper';
import { JwtApiClient } from '@jbhi-fi/apis/src/client/JwtApiClient';
import { CouponData, CustomerData, MetafieldData } from './types';
import { CouponWithoutContent, CustomerPreferences } from '@jbhi-fi/components/src/types';

const { themeApisUrl } = serviceHelper;

const customerHelper = new CustomerHelper();

export class ShopifyCustomerClient extends JwtApiClient {
  protected _refreshUrl = serviceHelper.customerAuthRefresh;
  protected _logout = handleShopifyLogout;

  updatePreferences = async ({
    customerId,
    preferences,
  }: {
    customerId: string;
    preferences: {
      [key: string]: string;
    };
  }): Promise<ApiResponse<CustomerPreferences>> => {
    const update = await customerHelper.setCustomerPreferences(customerId, preferences);

    if (!update?.isSuccess) return { statusCode: 400 };

    const { raw: customerData } = await customerHelper.getCustomerData(customerId);

    const updatedPreferences = (customerData as CustomerData)?.data?.preferences;

    const { data, statusCode, error } = await this._fetch<CustomerPreferences>({
      path: `${themeApisUrl}/authed/shopifyCustomer/SetPreferences`,
      method: 'POST',
      body: { customerId, preferences: updatedPreferences },
    });

    return { data: data as CustomerPreferences, statusCode, error };
  };
  updateCoupons = async ({
    customerId,
    coupons,
  }: {
    customerId: number;
    coupons: Array<CouponWithoutContent>;
  }): Promise<ApiResponse<CouponData>> => {
    const { data, statusCode, error } = await super._fetch<CouponData>({
      path: `${themeApisUrl}/authed/shopifyCustomer/SetCoupons`,
      method: 'POST',
      body: JSON.stringify({ customerId, coupons }),
    });
    return { data: data as CouponData, statusCode, error };
  };
  dismissAccountMessage = async (id: string): Promise<ApiResponse<MetafieldData>> => {
    const { data, statusCode, error } = await super._fetch<MetafieldData>({
      path: `${themeApisUrl}/authed/shopifyCustomer/DismissAccountMessage`,
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return { data: data as MetafieldData, statusCode, error };
  };
}
